module.exports = __webpack_public_path__ + "static/media/Logo_Blue_Reverse.82d164d9.svg";